<div class="tw:flex tw:flex-1 tw:min-h-0 tw:h-screen tw:overflow-hidden">
  @if (showSidebar()) {
    <div
      class="tw:bg-surface-50 tw:dark:bg-surface-800 tw:border-surface tw:border-r tw:shrink-0 tw:top-0 tw:hidden tw:lg:block tw:overflow-y-auto tw:h-screen">
      <cor-sidebar-nav />
    </div>
  }
  <p-splitter
    class="theme-body-splitter tw:flex tw:h-full tw:grow tw:min-w-0 tw:flex-auto tw:min-h-0 tw:border-0 tw:bg-transparent"
    panelStyleClass="theme-panel"
    [panelSizes]="aiChatDockService.isVisible() ? chatPanelSizes() : [100, 0]"
    [minSizes]="aiChatDockService.isVisible() ? [45, 24] : [100, 0]"
    [gutterSize]="0"
    (onResizeEnd)="onSplitterResizeEnd($event)"
    [class.theme-body-splitter--chat-open]="aiChatDockService.isVisible()">
    <ng-template pTemplate="panel">
      <div
        cdkScrollable
        class="tw:flex tw:flex-col tw:min-w-0 tw:overflow-auto tw:h-screen tw:bg-(--p-content-background) tw:flex-1 tw:max-w-full tw:overflow-x-clip tw:overflow-y-auto tw:relative">
        <cor-header-nav
          [unreadNotificationCount]="notifications.unreadCount()"
          (onNotiClick)="toggleNotificationSidebar()" />

        <p-drawer
          [(visible)]="notifications.isUnreadListOpen"
          header="Notifications"
          styleClass="notification-drawer tw:w-full tw:md:w-3/4 tw:lg:w-1/2"
          [blockScroll]="true"
          position="right">
          <div class="tw:flex tw:items-center tw:justify-between tw:p-2">
            <p-button
              test-id="theme-open-all-notifications"
              [buttonProps]="{ autofocus: false }"
              label="Open All Notifications"
              (click)="openNotificationDialog()"
              variant="text"
              styleClass="tw:py-0 tw:px-2" />
            @if (notifications.unreadCount() !== '') {
              <p-button
                test-id="theme-mark-all-as-read"
                [buttonProps]="{ autofocus: false }"
                label="Mark All as Read"
                (click)="onClearAllNotifications()"
                variant="text"
                styleClass="tw:float-right tw:py-0 tw:px-2" />
            }
          </div>

          <dx-data-grid
            [dataSource]="notifications.datasource"
            [tabIndex]="-1"
            [wordWrapEnabled]="true"
            [columnAutoWidth]="true"
            [hoverStateEnabled]="true"
            [showColumnHeaders]="false">
            <dxo-data-grid-paging [pageSize]="pageSize()" />
            <dxo-data-grid-remote-operations
              [paging]="true"
              [sorting]="true" />
            <dxi-data-grid-column
              [allowEditing]="true"
              caption="Name"
              dataField="renderedMessage"
              cellTemplate="nameTemplate"
              width="30%"
              dataType="string" />
            <!-- Name Template -->
            <div *dxTemplate="let data of 'nameTemplate'">
              <div
                test-id="theme-mark-as-read-and-redirect"
                class="tw:flex tw:gap-2 tw:w-full"
                (click)="markAsReadAndRedirect(data.data)">
                @if (data.data.template === TEMPLATE_FILTER_TYPE.REVIEW_STATUS_CHANGE) {
                  <p-avatar
                    class="tw:shrink-0 tw:mt-1"
                    [label]="data.data.createdBy | nameBadge"
                    style="--p-avatar-width: 2.4rem; --p-avatar-height: 2.4rem"
                    [ngStyle]="{
                      backgroundColor: (data.data.createdBy || '' | uniqueRgbColor),
                      color: 'white',
                    }"
                    shape="circle" />
                } @else if (
                  data.data.template === TEMPLATE_FILTER_TYPE.SIMULATION_STATUS_CHANGE &&
                  data.data?.messageData?.actionObjectInfo?.name
                ) {
                  @let notifColor = $any(notifications.colors)[data.data.type];
                  <div
                    [class]="`tw:flex tw:items-center tw:justify-center tw:rounded-full tw:shrink-0 tw:text-surface-0 tw:mt-1 tw:border-1 ${notifColor.backgroundClass}`"
                    style="width: 2.4rem; height: 2.4rem">
                    <i
                      [class]="
                        EXECUTION_ICON[data.data?.messageData?.actionObjectInfo?.name] +
                        ` ${notifColor.colorClass}`
                      "></i>
                  </div>
                } @else if (data.data?.messageData?.targetType) {
                  <div
                    class="tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:mt-1"
                    style="width: 2.4rem; height: 2.4rem"
                    [ngStyle]="data.data?.messageData?.targetType | objectIconPipe"
                    [title]="$any(OBJECT_DISPLAY_NAMES)[data.data?.messageData?.targetType]">
                    <i
                      [ngClass]="(data.data?.messageData?.targetType | objectIconPipe)?.icon"
                      style="color: inherit"></i>
                  </div>
                } @else {
                  <p-avatar
                    class="tw:shrink-0 tw:mt-1"
                    [label]="data.data.createdBy | nameBadge"
                    style="--p-avatar-width: 2.4rem; --p-avatar-height: 2.4rem"
                    [ngStyle]="{
                      backgroundColor: (data.data.createdBy || '' | uniqueRgbColor),
                      color: 'white',
                    }"
                    shape="circle" />
                }
                <div class="tw:flex tw:flex-col tw:grow">
                  <div
                    [ngStyle]="{ 'font-weight': data.data.isViewed ? 'normal' : '600' }"
                    test-id="notification-title">
                    {{ data.data.renderedMessage.title }}
                  </div>
                  <small
                    class="tw:text-color"
                    test-id="notification-desc">
                    {{ data.data.renderedMessage.message }}
                  </small>
                </div>
                <div class="tw:flex tw:flex-col tw:justify-between tw:items-end">
                  @let notifColor = $any(notifications.colors)[data.data.type];
                  <i
                    [class]="`${notifColor.iconClass} ${notifColor.colorClass}`"
                    [pTooltip]="data.data.type"></i>
                  <small
                    test-id="notification-time"
                    class="tw:whitespace-nowrap tw:text-muted-color">
                    {{ data.data.createdDate | dateFromNow }}
                  </small>
                </div>
              </div>
            </div>
          </dx-data-grid>
        </p-drawer>

        <p-dialog
          [(visible)]="notifications.isDialogOpen"
          header="Notifications"
          closeAriaLabel="Close Notifications"
          [modal]="true"
          [draggable]="false"
          [blockScroll]="true"
          [resizable]="false"
          [closeOnEscape]="true"
          [dismissableMask]="true"
          [focusOnShow]="false"
          appendTo="body"
          [style]="{
            width: '90vw',
            height: '90vh',
            overflow: 'hidden',
          }"
          [contentStyle]="{ padding: '0', overflow: 'auto' }">
          @if (notifications.isDialogOpen()) {
            <cor-notification />
          }
        </p-dialog>

        <p-dialog
          [(visible)]="learningHubService.isDialogVisible"
          header="Learning Hub"
          [modal]="true"
          [draggable]="false"
          [blockScroll]="true"
          [resizable]="false"
          [closeOnEscape]="true"
          [dismissableMask]="true"
          [focusOnShow]="false"
          appendTo="body"
          [style]="{
            width: 'min(1100px, 92vw)',
            height: '90vh',
            overflow: 'hidden',
            '--p-dialog-header-padding': '0.5rem 1rem 0',
          }"
          [contentStyle]="{ padding: '0', overflow: 'auto' }">
          @if (learningHubService.isDialogVisible()) {
            <cor-learning-hub />
          }
        </p-dialog>

        <!-- begin::Body -->
        <div class="tw:flex-[1_1_auto] tw:min-w-0">
          <router-outlet />
        </div>
        <!-- end::Body -->
        <cor-footer />
      </div>
    </ng-template>
    <ng-template pTemplate="panel">
      <div
        class="theme-chat-dock tw:h-full tw:min-w-0 tw:overflow-hidden tw:bg-(--p-content-background)"
        [class.theme-chat-dock--open]="aiChatDockService.isVisible()">
        @if (aiChatDockService.isVisible()) {
          <cor-ai-chat
            [messageToSend]="aiChatDockService.messageToSend()"
            [newChatRequestId]="aiChatDockService.newChatRequestId()"
            (messageToSendChange)="aiChatDockService.setMessageToSend($event)"
            (closeChat)="aiChatDockService.close()"
            (isLoadingChange)="aiChatDockService.setIsLoading($event)" />
        }
      </div>
    </ng-template>
  </p-splitter>
  <cor-ai-chat-handle class="tw:hidden" />
</div>
